export const hashString = (value: string): string => {
  let hash = 2166136261;

  for (let index = 0; index < value.length; index += 1) {
    const codePoint = value.codePointAt(index);

    if (codePoint === undefined) {
      break;
    }

    hash ^= codePoint;
    hash = Math.imul(hash, 16777619);

    if (codePoint > 0xffff) {
      index += 1;
    }
  }

  return (hash >>> 0).toString(16).padStart(8, '0');
};
